module.exports = __webpack_public_path__ + "static/media/IMG_2054.16dd0f40.jpg";